// @file Helper functions for parsing HTML

import { escapeHtml } from '@padlet/bits/src/html'

// Retrieve image src from element
const extractUrl = (str: string): string | null => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(str, 'text/html')
  const elem = doc.querySelector('iframe,img') as HTMLImageElement
  if (elem) {
    return elem.src
  } else {
    return null
  }
}

// https://stackoverflow.com/a/47140708/8943850
const stripHtml = (htmlStr: string): string => {
  const doc = new DOMParser().parseFromString(htmlStr, 'text/html')
  return doc.body.textContent ?? ''
}

export { escapeHtml, extractUrl, stripHtml }
